import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PlansSection } from "@/components/admin/meal-plans-v2/PlansSection";
import { DishesSection } from "@/components/admin/meal-plans-v2/DishesSection";
import { MealCombinationsSection } from "@/components/admin/meal-plans-v2/MealCombinationsSection";
import { FoodPreferencesSection } from "@/components/admin/meal-plans-v2/FoodPreferencesSection";
import { ServiceDayDurationsSection } from "@/components/admin/meal-plans-v2/ServiceDayDurationsSection";
import { DeliveryRulesSection } from "@/components/admin/meal-plans-v2/DeliveryRulesSection";
import { PricingSection } from "@/components/admin/meal-plans-v2/PricingSection";

export const Route = createFileRoute("/_admin/admin/meal-plans-v2")({
  component: MealPlansV2AdminPage,
});

function MealPlansV2AdminPage() {
  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="Subscription Plans & Catalog"
        description="Manage your subscription plans, catalog references, and pricing matrix."
        actions={null}
      />
      <Tabs defaultValue="plans" className="space-y-4">
        <TabsList className="flex-wrap bg-muted/50 p-1 w-full justify-start overflow-x-auto no-scrollbar whitespace-nowrap">
          <TabsTrigger value="plans">Subscription Plans</TabsTrigger>
          <TabsTrigger value="pricing">Pricing Engine</TabsTrigger>
          <TabsTrigger value="catalog">Catalog Reference</TabsTrigger>
        </TabsList>
        <TabsContent value="plans">
          <PlansSection />
        </TabsContent>
        <TabsContent value="pricing">
          <PricingSection />
        </TabsContent>
        <TabsContent value="catalog">
          <Tabs defaultValue="dishes" className="space-y-4">
            <TabsList className="bg-muted/50 p-1 w-full justify-start overflow-x-auto no-scrollbar whitespace-nowrap">
                <TabsTrigger value="dishes">Dish Library</TabsTrigger>
                <TabsTrigger value="combinations">Meal Combinations</TabsTrigger>
                <TabsTrigger value="preferences">Food Preferences</TabsTrigger>
                <TabsTrigger value="durations">Durations</TabsTrigger>
                <TabsTrigger value="rules">Delivery Rules</TabsTrigger>
            </TabsList>
            <TabsContent value="dishes" className="pt-2"><DishesSection /></TabsContent>
            <TabsContent value="combinations" className="pt-2"><MealCombinationsSection /></TabsContent>
            <TabsContent value="preferences" className="pt-2"><FoodPreferencesSection /></TabsContent>
            <TabsContent value="durations" className="pt-2"><ServiceDayDurationsSection /></TabsContent>
            <TabsContent value="rules" className="pt-2"><DeliveryRulesSection /></TabsContent>
          </Tabs>
        </TabsContent>
      </Tabs>
    </div>
  );
}
